import SectionTitle from "./SectionTitle";
import { quickIssues } from "@/mocks/home";

export default function QuickIssues() {
  return (
    <section id="issues" className="bg-background-100 border-y border-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionTitle
          eyebrow="问题速查"
          title="先看看你属于哪一种情况"
          desc="把高频问题分成四类，点击卡片直接跳到对应分区的详细解决步骤，不用从头读到尾。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {quickIssues.map((item) => (
            <a
              key={item.id}
              href={item.anchor}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 transition-colors hover:border-primary-300"
            >
              <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="inline-flex self-start px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-medium mb-2">
                {item.tag}
              </span>
              <h3 className="text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-700 font-medium">
                查看解决方法
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}